import './App.css';
import Navbar from './components/navbar/navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/home';
import ShopCategory from './pages/shopCategory';
import Product from './pages/product';
import Cart from './pages/cart';
import LoginSignup from './pages/loginSignup';
import Footer from './components/footer/footer'
import Favourites from './pages/favourites';
import CheckoutSuccess from './pages/checkoutSuccess'
import Account from './pages/account'
import PageNotFound from './pages/404';
import TermsOfUse from './pages/termsOfUse';
import MobileTermsOfService from './pages/mobileTermsOfService'
import Privacy from './pages/privacyPolicy';
import Cookies from './pages/cookiesPolicy'
import AboutUs from './pages/aboutUs'
import SearchResults from './pages/search'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path='/favourites' element={<Favourites />} />
          <Route path='/' element={<Home />} />
          <Route path='/wedding' element={<ShopCategory category='wedding' />} />
          <Route path='/birthday' element={<ShopCategory category='birthday' />} />
          <Route path='/engagement' element={<ShopCategory  category='engagement' />} />
          <Route path='/get-well' element={<ShopCategory  category='get well' />} />
          <Route path='/all' element={<ShopCategory  category='all' />} />

          <Route path='/card/:productId' element={<Product />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/order-confirmation' element={<CheckoutSuccess />} />
          <Route path='/login' element={<LoginSignup />} />
          <Route path='/account' element={<Account />} />

          <Route path="/search" element={<SearchResults />} />
          <Route path='/about' element={<AboutUs />} />
          <Route path='/terms-of-use' element={<TermsOfUse />} />
          <Route path='/mobile-terms-of-service' element={<MobileTermsOfService />} />
          <Route path='/privacy-policy' element={<Privacy />} />
          <Route path='/cookie-policy' element={<Cookies />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;